import { formatAssetsUrl } from '@whitbread-eos/utils';
import { useEffect } from 'react';
export default function AmazonChatIcon(_ref) {
  var amazonChatIcon = _ref.amazonChatIcon;
  useEffect(() => {
    var style = document.createElement('style');
    style.innerHTML = "\n      #amazon-connect-open-widget-button {\n        background: unset !important;\n        width: unset !important;\n        box-shadow: unset !important;\n        max-width: 220px;\n        transition: unset;\n      }\n      #amazon-connect-close-widget-button #live-chat-gif-icon,\n      #amazon-connect-open-widget-button > svg {\n        display: none !important;\n      }\n      #amazon-connect-open-widget-button[class^=\"acOpenButton\"] {\n        outline: none;\n      }\n    ";
    document.head.appendChild(style);
    var observer = new MutationObserver((mutations, obs) => {
      var button = document.querySelector('#amazon-connect-open-widget-button');
      if (button) {
        button === null || button === void 0 || button.setAttribute('aria-label', 'Open chat support');
        var img = document.createElement('img');
        img.id = 'live-chat-gif-icon';
        img.src = formatAssetsUrl(amazonChatIcon);
        button.appendChild(img);
        obs.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    return () => {
      observer.disconnect();
      document.head.removeChild(style);
    };
  }, []);
  return null;
}